export const brLine = value => {
  return value.replace(/^\s+|\s+$/gm, '$&<br>');
};
